var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { "grid-list-xl": "", fluid: "" } },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs8: "", "offset-xs2": "" } },
            [
              _c(
                "v-btn",
                { attrs: { small: "", color: "primary", to: "/fabrics" } },
                [_vm._v("Back to Fabrics")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    large: "",
                    fab: "",
                    fixed: "",
                    bottom: "",
                    right: "",
                    color: "primary",
                    to: { name: "New Color" }
                  }
                },
                [_c("v-icon", [_vm._v("add")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    [
                      _vm.fabric
                        ? _c("h4", [
                            _vm._v(
                              "Colours in " +
                                _vm._s(_vm.fabric.name) +
                                " (" +
                                _vm._s(_vm.colours.length) +
                                ")"
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c("v-text-field", {
                        attrs: {
                          "append-icon": "search",
                          label: "Search",
                          "single-line": "",
                          "hide-details": ""
                        },
                        model: {
                          value: _vm.search,
                          callback: function($$v) {
                            _vm.search = $$v
                          },
                          expression: "search"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-data-table",
                    {
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.colours,
                        search: _vm.search,
                        loading: _vm.colorsLoading
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "items",
                          fn: function(props) {
                            return [
                              _c("td", [_vm._v(_vm._s(props.item.name))]),
                              _vm._v(" "),
                              props.item.express
                                ? _c("td", [_vm._v("Express")])
                                : _c("td"),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c(
                                    "button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.deleteColour(
                                            props.item._id
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                  _vm._v(" "),
                                  props.item.express
                                    ? _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.setExpress(
                                                props.item._id,
                                                false
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Disable Express")]
                                      )
                                    : _c(
                                        "button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.setExpress(
                                                props.item._id,
                                                true
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Enable Express")]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "Edit Color",
                                          params: { colorID: props.item._id }
                                        }
                                      }
                                    },
                                    [
                                      _vm._v("Edit "),
                                      props.item.tags
                                        ? _c("span", [
                                            _vm._v(
                                              "(" +
                                                _vm._s(props.item.tags.length) +
                                                ")"
                                            )
                                          ])
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              )
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _c("v-progress-linear", {
                        attrs: {
                          slot: "progress",
                          color: "primary",
                          indeterminate: ""
                        },
                        slot: "progress"
                      }),
                      _vm._v(" "),
                      _vm._v(" "),
                      _c("template", { slot: "no-data" }, [
                        _vm._v("\n            Loading...\n          ")
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cd62802", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cd62802","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/colours/Colours.vue
// module id = null
// module chunks = 